module.exports = __webpack_public_path__ + "static/media/noite.c078228f.svg";